import Icon from '../components/Icon.vue'

Icon.register({
  thermometer: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M476.8 20.4c49.4 40.7 42.1 107.3 7.2 142.2l-254.2 253.3h-99.9l-89 89c-9.3 9.4-24.5 9.4-33.9 0-9.4-9.3-9.4-24.5 0-33.9l89-89v-100.9l45.3-45.7 50.1 50.2c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-50.1-50.2 45.1-45.4 50.3 50.2c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-50.3-50.4 45.1-45.4 50.4 50.5c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-50.5-50.5 45.7-46c36.4-36.5 94.4-40.9 131.9-10.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/thermometer.js
// module id = 2005
// module chunks = 0